// import { Chip } from "@mui/material";

// const getStatusColor = (status) => {
//   const statusLower = status?.toLowerCase() || "";

//   if (statusLower.includes("drop") || statusLower.includes("depot") || statusLower.includes("depo")) {
//     return { bgcolor: "#04384d", color: "#fff" };
//   }
//   if (
//     statusLower.includes("inqueue") ||
//     statusLower.includes("in queue") ||
//     statusLower.includes("waitingqueue") ||
//     statusLower.includes("waiting queue") ||
//     statusLower === "queue"
//   ) {
//     return { bgcolor: "#1E3A8A", color: "#fff" };
//   }
//   if (statusLower.includes("waiting")) {
//     return { bgcolor: "#9E9E9E", color: "#fff" };
//   }

//   if (statusLower.includes("progress")) {
//     return { bgcolor: "#2196F3", color: "#fff" }; // Blue
//   }
//   if (statusLower.includes("paused")) {
//     return { bgcolor: "#FF9800", color: "#fff" }; // Orange
//   }
//   if (statusLower.includes("canceled")) {
//     return { bgcolor: "#F44336", color: "#fff" }; // Red
//   }
//   if (statusLower.includes("unload")) {
//     return { bgcolor: "#9C27B0", color: "#fff" }; // Purple
//   }
//   if (statusLower.includes("ready")) {
//     return { bgcolor: "#00BCD4", color: "#fff" }; // Cyan
//   }
//   if (statusLower.includes("transit")) {
//     return { bgcolor: "#3F51B5", color: "#fff" }; // Indigo
//   }
//   if (statusLower.includes("delivered")) {
//     return { bgcolor: "#4CAF50", color: "#fff" }; // Green
//   }
//   if (statusLower.includes("loaded")) {
//     return { bgcolor: "#00BCD4", color: "#fff" };
//   }

//   return { bgcolor: "#9E9E9E", color: "#fff" }; // Gray for unknown
// };

// export const getColumns = () => [
//   // {
//   //   field: "job_id",
//   //   headerName: "Job No",
//   //   flex: 1,
//   //   minWidth: 120,
//   // },

//   {
//     field: "invoice_number",
//     headerName: "Invoice No",
//     flex: 1,
//     minWidth: 120,
//   },
//   {
//     field: "assigned_driver",
//     headerName: "Driver",
//     flex: 1,
//     minWidth: 150,
//   },
//   {
//     field: "customer",
//     headerName: "Customer",
//     flex: 1,
//     minWidth: 150,
//   },

//   {
//     field: "invoice_date",
//     headerName: "Invoice Date",
//     flex: 1,
//     minWidth: 180,
//   },
//   // {
//   //   field: "order_date",
//   //   headerName: "Order Date",
//   //   flex: 1,
//   //   minWidth: 180,
//   // },
//   // {
//   //   field: "delivery_date",
//   //   headerName: "Delivery Date",
//   //   flex: 1,
//   //   minWidth: 130,
//   // },

//   {
//     field: "delivery_completed_date",
//     headerName: "Delivered Date",
//     flex: 1,
//     minWidth: 130,
//   },
//   {
//     field: "total_order_lines",
//     headerName: "Order Lines",
//     flex: 1,
//     minWidth: 80,
//     align: "center",
//     headerAlign: "center",
//   },
//     {
//     field: "total_invoice_count",
//     headerName: "Invoice Count",
//     flex: 1,
//     minWidth: 80,
//     align: "center",
//     headerAlign: "center",
//   },
//   {
//     field: "delivery_status",
//     headerName: "Status",
//     flex: 1,
//     minWidth: 150,
//     renderCell: (params) => {
//       const status = params.value;

//       // Only render chip if status exists
//       if (!status) {
//         return null;
//       }

//       const colorProps = getStatusColor(status);

//       return (
//         <Chip
//           label={status}
//           sx={{
//             ...colorProps,
//             fontWeight: 500,
//             fontSize: "12px",
//             height: "28px",
//           }}
//         />
//       );
//     },
//   },

//   // {
//   //   field: "assigned_driver",
//   //   headerName: "Driver",
//   //   flex: 1,
//   //   minWidth: 150,
//   // },
//   {
//     field: "bay",
//     headerName: "Bay",
//     flex: 1,
//   },
// ];


import { Chip } from "@mui/material";

const getStatusColor = (status) => {
  const statusLower = status?.toLowerCase() || "";

  if (statusLower.includes("drop") || statusLower.includes("depot") || statusLower.includes("depo")) {
    return { bgcolor: "#04384d", color: "#fff" };
  }
  if (
    statusLower.includes("inqueue") ||
    statusLower.includes("in queue") ||
    statusLower.includes("waitingqueue") ||
    statusLower.includes("waiting queue") ||
    statusLower === "queue"
  ) {
    return { bgcolor: "#1E3A8A", color: "#fff" };
  }
  if (statusLower.includes("waiting")) {
    return { bgcolor: "#9E9E9E", color: "#fff" };
  }

  if (statusLower.includes("progress")) {
    return { bgcolor: "#2196F3", color: "#fff" }; // Blue
  }
  if (statusLower.includes("paused")) {
    return { bgcolor: "#FF9800", color: "#fff" }; // Orange
  }
  if (statusLower.includes("canceled")) {
    return { bgcolor: "#F44336", color: "#fff" }; // Red
  }
  if (statusLower.includes("unload")) {
    return { bgcolor: "#9C27B0", color: "#fff" }; // Purple
  }
  if (statusLower.includes("ready")) {
    return { bgcolor: "#00BCD4", color: "#fff" }; // Cyan
  }
  if (statusLower.includes("transit")) {
    return { bgcolor: "#3F51B5", color: "#fff" }; // Indigo
  }
  if (statusLower.includes("delivered")) {
    return { bgcolor: "#4CAF50", color: "#fff" }; // Green
  }
  if (statusLower.includes("loaded")) {
    return { bgcolor: "#00BCD4", color: "#fff" };
  }
  if (statusLower.includes("suspend")) {
    return { bgcolor: "#C2185B", color: "#fff" }; // Pink
  }
  if (statusLower.includes("return")) {
    return { bgcolor: "#8D6E63", color: "#fff" }; // Brown
  }

  return { bgcolor: "#9E9E9E", color: "#fff" }; // Gray for unknown
};

export const getColumns = (activeTab) => [
  {
    field: "invoice_number",
    headerName: "Invoice No",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "customer",
    headerName: "Customer",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "invoice_date",
    headerName: "Invoice Date",
    flex: 1,
    minWidth: 180,
  },
  {
    field: "delivery_date",
    headerName: "Delivery Date",
    flex: 1,
    minWidth: 180,
  },
  ...(["inQueue", "all"].includes(activeTab)
    ? [
        {
          field: "delivery_completed_date",
          headerName: "Delivered Date",
          flex: 1,
          minWidth: 130,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => {
            const value = params.value;
            // Show "-" centered if value is empty, null, undefined, or just whitespace
            if (!value || value.toString().trim() === "") {
              return <span style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>-</span>;
            }
            return <span style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>{value}</span>;
          },
        },
      ]
    : []),
  ...(activeTab === "waitingQueue"
    ? [
        {
          field: "delivery_iqueue_date",
          headerName: "In Queue Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(["inProgress", "paused", "postpone", "loaded", "inTransit", "dropToDepo", "delivered", "unload", "canceled", "suspend", "return"].includes(activeTab)
    ? [
        {
          field: "delivery_inprogress_date",
          headerName: "In Progress Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(activeTab === "paused"
    ? [
        {
          field: "delivery_paused_date",
          headerName: "Paused Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(["postpone", "loaded", "inTransit", "dropToDepo", "delivered", "suspend", "return"].includes(activeTab)
    ? [
        {
          field: "delivery_loaded_date",
          headerName: "Loaded Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(["postpone", "inTransit", "delivered", "suspend", "return"].includes(activeTab)
    ? [
        {
          field: "delivery_start_date",
          headerName: "Start To Delivery",
          flex: 1,
          minWidth: 180,
        },
      ]
    : []),
  ...(activeTab === "delivered"
    ? [
        {
          field: "delivery_completed_date",
          headerName: "Delivered Date",
          flex: 1,
          minWidth: 130,
          align: "center",
          headerAlign: "center",
          renderCell: (params) => {
            const value = params.value;
            if (!value || value.toString().trim() === "") {
              return <span style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>-</span>;
            }
            return <span style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>{value}</span>;
          },
        },
      ]
    : []),
  ...(activeTab === "dropToDepo"
    ? [
        {
          field: "invoice_drop_to_depo_date",
          headerName: "Drop Date",
          flex: 1,
          minWidth: 160,
        },
        {
          field: "invoice_drop_to_depo_name",
          headerName: "Depot Name",
          flex: 1,
          minWidth: 150,
        },
      ]
    : []),
  ...(activeTab === "postpone"
    ? [
        {
          field: "invoice_postpone_date",
          headerName: "Postponed Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(activeTab === "unload"
    ? [
        {
          field: "delivery_unload_date",
          headerName: "Unloaded Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(activeTab === "canceled"
    ? [
        {
          field: "delivery_cancel_date",
          headerName: "Cancelled Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(activeTab === "suspend"
    ? [
        {
          field: "invoice_suspend_date",
          headerName: "Suspended Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  ...(activeTab === "return"
    ? [
        {
          field: "delivery_return_date",
          headerName: "Return Date",
          flex: 1,
          minWidth: 160,
        },
      ]
    : []),
  {
    field: "total_order_lines",
    headerName: "Order Lines",
    flex: 1,
    minWidth: 80,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "delivery_status",
    headerName: "Status",
    flex: 1,
    minWidth: 150,
    renderCell: (params) => {
      const status = params.value;

      if (!status) {
        return null;
      }

      const colorProps = params.row.delivery_status_color
        ? { bgcolor: params.row.delivery_status_color, color: "#fff" }
        : getStatusColor(status);

      return (
        <Chip
          label={status}
          sx={{
            ...colorProps,
            fontWeight: 500,
            fontSize: "12px",
            height: "28px",
          }}
        />
      );
    },
  },
];